const APLinesColumns = [
    { headerName: 'Charge Type', field: 'chargeType' },
    { headerName: 'Brand', field: 'brand' },
    { headerName: 'Charge Period', field: 'chargePeriod' },
    { headerName: 'Charge Code', field: 'chargeCode' },
    { headerName: 'RA Number', field: 'raNumber' },
    { headerName: 'Renting Country', field: 'rentingCountry' },
    { headerName: 'Checkout Location', field: 'cOutLoc' },
    { headerName: 'Checkout Date', field: 'cOutDate' },
    { headerName: 'Cost Centre', field: 'costCentre' },
    { headerName: 'Renting TM', field: 'rentTM' },
    { headerName: 'Bonus Rate', field: 'bonusRate' },
    { headerName: 'Foreign Commission', field: 'foreignComm' },
    { headerName: 'Domestic Commission', field: 'domesticComm' },
    { headerName: 'Renting Currency', field: 'rentingCurrency' },
    { headerName: 'Account Number', field: 'accountNo' },
    { headerName: 'Billing Country', field: 'billingCountry' },
    { headerName: 'Commission Billing Value', field: 'commissionBillValue' },
    { headerName: 'Billing Currency', field: 'billingCurrency' },
    { headerName: 'Bonus Amount', field: 'bonusAmount' },
    { headerName: 'Exchange Rate', field: 'exchRate' },
    { headerName: 'Currency Code', field: 'currencyCode' }
];

export default APLinesColumns;

  